<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div class="pt-5" v-else>
    <div class="row">
      <div class="col pt-5">
        <h5>Import status</h5>
      </div>
      <div class="col text-right">
        <button class="btn btn-outline-secondary" @click="refreshImportStatus">
          Refresh
        </button>
      </div>
    </div>
    <div>
      <b-table
        class="table table-responsive table-bordered mt-1"
        hover
        responsive
        :fields="fields"
        :items="listImportStatus"
      >
        <template #cell(fileName)="data">
          <a :href="data.item.fileUrl" target="_blank">{{ data.value }}</a>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import ProductDisplayNameService from "services/api/productDisplayName.service";

export default {
  data() {
    return {
      isLoading: false,
      listImportStatus: [],
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "fileName",
          label: "File Name",
          sortable: true,
        },
        {
          key: "date",
          label: "Date time",
          sortable: true,
        },
        {
          key: "result",
          label: "Result",
          sortable: true,
        },
      ],
    };
  },
  mounted() {
    this.isLoading = true;
    this.getImportStatusList();
  },
  methods: {
    async getImportStatusList() {
      await ProductDisplayNameService.getListImportFileStatus()
        .then((res) => {
          const data = res.data;
          this.listImportStatus = data.status;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log("Error: ", err);
          this.isLoading = false;
        });
    },
    refreshImportStatus() {
      this.isLoading = true;
      this.getImportStatusList();
    },
  },
};
</script>
